export const cadenaResultante = (listaObjetos) => listaObjetos.map(obj => `${obj.id}-${obj.importe || 0}-${obj.saldoDisponible || 0}`).join(',');

export const eliminarDuplicadosPorId = (lista) => {
    const idsVistos = new Set();
    return lista.filter((elemento) => !idsVistos.has(elemento.id) && idsVistos.add(elemento.id));
  }
  
export function compararObjetos(objeto1, objeto2) {
  const diferencias = [];

  for (const propiedad in objeto1) {
    if (objeto1.hasOwnProperty(propiedad) && objeto2.hasOwnProperty(propiedad)) {
      const valorObjeto1 = objeto1[propiedad];
      const valorObjeto2 = objeto2[propiedad];

      // Verificar si los valores son diferentes, considerando casos especiales
      if (valorObjeto1 !== valorObjeto2 && !([null, undefined, ''].includes(valorObjeto1) && [null, undefined, ''].includes(valorObjeto2))) {
        diferencias.push({
          propiedad,
          valorObjeto1,
          valorObjeto2
        });
      }
    }
  }

  return diferencias;
}